import React, { useState } from 'react';
import { Avatar, Typography, Button, Space, Badge, Tooltip } from 'antd';
import { UserOutlined, TeamOutlined, SearchOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Room } from '../../types/chat';
import NotificationSettings from './NotificationSettings';
import SearchMessages from './SearchMessages';

const { Text } = Typography;

interface ChatHeaderProps {
  room: Room;
  roomId: string | null;
  toggleMembersSidebar: () => void;
  membersSidebarCollapsed: boolean;
  onlineMembersCount?: number;
  onJumpToMessage?: (eventId: string) => void;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({ 
  room, 
  roomId,
  toggleMembersSidebar, 
  membersSidebarCollapsed,
  onlineMembersCount = 0,
  onJumpToMessage
}) => {
  const { t } = useTranslation();
  const [searchVisible, setSearchVisible] = useState(false);

  return (
    <>
      <div className="chat-header">
        <Avatar 
          size="large"
          style={{ backgroundColor: room.display_name ? '#1677ff' : '#87d068' }}
          icon={<UserOutlined />}
        />
        <div className="room-header-info">
          <Text strong>{room.display_name || roomId || 'Unknown'}</Text>
          <Text type="secondary" ellipsis style={{ fontSize: 12 }}>
            {room.topic || 'No topic set'}
          </Text>
        </div>
        <div className="header-actions">
          <Space>
            <Tooltip title={t('search.title', 'Search Messages')}>
              <Button
                type="text"
                icon={<SearchOutlined />}
                onClick={() => setSearchVisible(true)}
                className="search-button"
              />
            </Tooltip>
            <Badge 
              count={onlineMembersCount} 
              overflowCount={99}
              style={{ backgroundColor: '#52c41a' }}
              size="small"
            >
              <Button
                type="text"
                icon={<TeamOutlined />}
                onClick={toggleMembersSidebar}
                className={membersSidebarCollapsed ? '' : 'active-icon'}
              />
            </Badge>
          </Space>
        </div>
      </div>

      {/* Модальное окно поиска */}
      <SearchMessages
        visible={searchVisible}
        onClose={() => setSearchVisible(false)}
        roomId={roomId || ''}
        roomName={room.display_name || roomId || 'Room'}
        onJumpToMessage={onJumpToMessage}
      />
    </>
  );
};

export default ChatHeader; 